module.exports = __webpack_public_path__ + "img/houtai_kejianshuju.567b681a.png";